import React from 'react'
import { TestAttributesConfig } from 'react-test-attributes'
import GAEventContextManager from 'shared/components/context/ga-event-manager'
import ModalContextManager from 'shared/components/context/modal-manager'
import ReduxBridgeManager from 'shared/components/context/redux-bridge-manager'
import RefreshDataContextManager from 'shared/components/context/refresh-data-manager'
import { attributeName } from 'shared/util/cy-test'
import CollectionsManager from './components/context/add-to-collections-manager'
import EditAPIContextManager from './components/context/edit-api-manager'
import VideoInlinePlayManager from './components/context/video-inline-play-manager'
import VideoLoopManager from './components/context/video-loop-manager'
import VideoMainManager from './components/context/video-main-manager'
import { FlashMessagesProvider } from './components/flash-message/flash-message'

const ContextManagers = ({ children }) => (
    <ReduxBridgeManager>
        <GAEventContextManager>
            <TestAttributesConfig value={{ suffix: attributeName, enableInProductionMode: true }}>
                <VideoLoopManager>
                    <VideoInlinePlayManager>
                        <VideoMainManager>
                            <RefreshDataContextManager>
                                <EditAPIContextManager>
                                    <CollectionsManager>
                                        <ModalContextManager>
                                            <FlashMessagesProvider>{children}</FlashMessagesProvider>
                                        </ModalContextManager>
                                    </CollectionsManager>
                                </EditAPIContextManager>
                            </RefreshDataContextManager>
                        </VideoMainManager>
                    </VideoInlinePlayManager>
                </VideoLoopManager>
            </TestAttributesConfig>
        </GAEventContextManager>
    </ReduxBridgeManager>
)

export default ContextManagers
